<template>
    <v-row>
        <v-col cols="12" class="title-section pb-0">
            {{ $t('common.last_upload') }}
        </v-col>
        <v-col cols="12">
            <div class="card-container">
                <v-row>
                    <v-col cols="12">
                        <youtube-iframe v-if="currentLink" :link="currentLink" height="181"/>
                        <div v-else class="subtitle-section">
                            {{ $t('common.no_links_yet') }}
                        </div>
                    </v-col>
                    <v-col cols="12" align="right" class="pt-0">
                        <v-btn class="normal-btn black--text" color="primary" depressed @click="showUploadLinksDialog">
                            {{ $t('common.upload_links') }} <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                        <youtube-upload-links-dialog ref="links"/>
                    </v-col>
                </v-row>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import YoutubeIframe from "@/components/common/YoutubeIframe";
import YoutubeUploadLinksDialog from "@/components/coach/YoutubeUploadLinksDialog";
export default {
    name: "YoutubeUploadLinks",
    components: {YoutubeUploadLinksDialog, YoutubeIframe},
    computed: {
        links(vm = this) {
            return vm.account?.links || []
        },
        currentLink(vm = this) {
            if(vm.links.length === 0) return null
            if(vm.links.length === 1) return vm.links[0]
            if(vm.links.length === 2) return vm.links[1]
            if(vm.links.length === 3) return vm.links[2]
            return null
        }
    },
    methods: {
        showUploadLinksDialog() {
            const vm = this
            vm.$refs.links.show()
        }
    }
}
</script>

<style scoped>

.title-section {
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
}

.subtitle-section {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
}

.card-container {
    border: thin solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    overflow: hidden;
    padding: 12px;
}

</style>